import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import CommunicationAdditionalInfo from '../../PhoneNumbers/PhoneNumberDisplay/CommunicationAdditionalInfo';
function Email(props) {
  var email = props.item,
    noLink = props.noLink,
    shortDisplay = props.shortDisplay;
  if (_.isEmpty(email)) {
    return null;
  }
  if (noLink) {
    return /*#__PURE__*/React.createElement("div", {
      className: "email"
    }, /*#__PURE__*/React.createElement("p", null, email.email_address));
  }
  var additionalInfo = /*#__PURE__*/React.createElement(CommunicationAdditionalInfo, {
    communicationTypes: email.acceptable_communication_types,
    isPrimary: email.is_primary
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "email"
  }, !shortDisplay && additionalInfo, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("a", {
    href: "mailto:".concat(email.email_address),
    title: email.email_address
  }, _.truncate(email.email_address, {
    length: 40
  }))));
}
Email.propTypes = {
  item: PropTypes.object,
  shortDisplay: PropTypes.bool,
  noLink: PropTypes.bool
};
export default Email;
//# sourceMappingURL=index.js.map